import { Record } from 'immutable';

export default class BookingInvoiceItemRecord extends Record({
  id: undefined,
  attestedDates: undefined,
  bookedDates: undefined,
  booking: undefined,
  createdAt: undefined,
  description: undefined,
  included: undefined, // FE Usage
  internalCreditOrDebit: undefined, // FE Usage
  internalDates: undefined, // FE Usage
  internalPrice: undefined, // FE Usage
  links: undefined,
  resource: undefined,
  totalAttestedPrice: undefined,
  totalAttestedVat: undefined,
  totalBookedPrice: undefined,
  totalBookedVat: undefined,
  vatRate: undefined,
}) {
}
